import type { SVGProps } from 'react';
const SvgOfflineBolt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#offline_bolt_svg__a)">
      <path
        fill="currentColor"
        d="M12 2.02c-5.51 0-9.98 4.47-9.98 9.98 0 5.51 4.47 9.98 9.98 9.98 5.51 0 9.98-4.47 9.98-9.98 0-5.51-4.47-9.98-9.98-9.98ZM11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20Z"
      />
    </g>
    <defs>
      <clipPath id="offline_bolt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOfflineBolt;
